import type { ChartData, ChartOptions } from "chart.js";
import { Chart } from "primereact/chart";
import {
  TEXT_COLOR,
  INDIGO_COLOR,
  PURPLE_COLOR,
  TEAL_COLOR,
  INDIGO_LIGHT_COLOR,
  PURPLE_LIGHT_COLOR,
  TEAL_LIGHT_COLOR,
} from "../../../styles/theme_constants";

interface PieChartProps {
  labels?: string[];
  datasets?: ChartData["datasets"];
  customOptions?: Partial<ChartOptions>;
  title?: string;
}

const PieChart: React.FC<PieChartProps> = ({
  labels = ["A", "B", "C"],
  datasets = [
    {
      data: [540, 325, 702],
      backgroundColor: [INDIGO_COLOR, PURPLE_COLOR, TEAL_COLOR],
      hoverBackgroundColor: [
        INDIGO_LIGHT_COLOR,
        PURPLE_LIGHT_COLOR,
        TEAL_LIGHT_COLOR,
      ],
    },
  ],
  customOptions = {},
  title = "Pie Chart",
}) => {
  const chartData: ChartData = {
    labels,
    datasets,
  };

  const chartOptions: ChartOptions = {
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          color: TEXT_COLOR,
        },
      },
    },
    ...customOptions,
  };

  return (
    <div className="col-12">
      <div className="card flex flex-column align-items-center">
        <h5 className="text-left w-full">{title}</h5>
        <Chart type="pie" data={chartData} options={chartOptions} />
      </div>
    </div>
  );
};

export default PieChart;
